export default __webpack_public_path__ + "static/media/Step 6 Image.65fd9e2c.png";